// extracted by mini-css-extract-plugin
export default {"container":"script-menu_container__FXa9A","main":"script-menu_main__QPbVs","grid":"script-menu_grid__ell8o","title":"script-menu_title__cOyb4"};